export const CONNECTWISE_CONSTANTS = {
    Migration: 0,
    Backup: 1,
    All: 0,
    SortingOption: {
        Ascending: 0,
        Descending: 1
    }
}
